import { IconDefinition } from "@fortawesome/fontawesome-svg-core"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

interface Props {
  activeMultiple?: boolean
  color?: string | null
  hideIcon?: boolean
  icon: IconDefinition
  isActive?: boolean
  name: string
  onAddClick?: () => void
  onClick?: () => void
  onRemoveClick?: () => void
}

export default function FilterChip({
  activeMultiple = false,
  color,
  hideIcon,
  icon,
  isActive,
  name,
  onAddClick,
  onClick,
  onRemoveClick
}: Props) {
  const activeColor = color ?? "#8C8C8C"
  const secondaryAction = onAddClick ?? onRemoveClick
  const secondaryActionLabel = onRemoveClick ? "-" : "+"
  const isSecondaryActionVisible = Boolean(secondaryAction) || activeMultiple

  return (
    <button
      type="button"
      className={`grey-t flex max-w-full items-center rounded-full bg-white py-[4px] font-normal _hover ${
        isSecondaryActionVisible ? "pl-[8px] pr-[6px]" : "px-[14px]"
      }`}
      onClick={(e) => {
        e.stopPropagation()
        onClick?.()
      }}
      style={{
        backgroundColor: isActive ? activeColor : "white",
        border: `1px solid ${isActive ? activeColor : "#D1D1D1"}`,
        color: isActive ? "white" : undefined
      }}>
      {!hideIcon && (
        <FontAwesomeIcon
          icon={icon}
          className="mr-[6px] shrink-0"
          style={{ color: isActive ? "white" : (color ?? undefined) }}
        />
      )}
      <span className="min-w-0 truncate">{name}</span>
      {isSecondaryActionVisible && (
        <span
          className="ml-[4px] flex h-[12px] w-[12px] shrink-0 items-center justify-center rounded-full text-[10px] leading-none opacity-70 _hover"
          onClick={(e) => {
            e.stopPropagation()
            secondaryAction?.()
          }}
          style={{ border: "1px solid currentColor" }}>
          {secondaryActionLabel}
        </span>
      )}
    </button>
  )
}
